import { useRef } from "react";
import { Card, CardContent, Badge } from "@deere/fuel-react";
import { Row, Col } from "../../components/Layout";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { log } from "../../Helper";
import { useState, useEffect } from "react";
import AddressContent from "./Address";
import TransportationContent from "./Transportation&Costing";
import Logs from "./Logs";
import MachineTab from "./MachineTab";
import RouteIcon from "@mui/icons-material/Route";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import {
  PostShipHoldDetails,
  PostUrgentDetails,
  getAuditDetails,
} from "../api.js";
import { toast } from "react-toastify";
import { Button, Typography } from "@mui/material";
import ReleaseIcon from "@mui/icons-material/PlayCircleOutline";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import ShipHoldDialog from "./ShipHoldDialog.js";
import DateAndStatusesContent from "./DatesAndStatuses.jsx";
import Documents from "./Documents.jsx";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ConfirmEditAddressDialog from "./ConfirmEditAddressDialog.jsx";
import { isEditDisabled as getEditDisabled } from "../../utils/isControlTowerEditDisabled.js";
import { STATUS_LIST } from "../utility/constants.js";
import LoaderComponent from "../../LoaderComponent/LoaderComponent.jsx";

const MachineMilestone = (props) => {
  const {
    shipToDetails,
    getShipToDetailsForMachine,
    orderUnit,
    orderNumber,
    orderYear,
    milestoneDetails,
    countryDealersList,
    isUserAdmin,
    userId,
    controlTowerPermissions,
    serial17,
    setIsLoading, // Accept the setIsLoading function
    locationList,
    logisticUnits,
    providerId,
  } = props;


  // Sort milestone details based on their sequence
  const sortedMileStoneDetails = milestoneDetails
    ?.slice()
    .sort((a, b) => a.pathDetails?.sequence - b.pathDetails?.sequence);

  const [anchorEl, setAnchorEl] = useState(null); // State for dropdown menu
  const open = Boolean(anchorEl);

  // State variables for tab and step management
  const [tabValue, setTabValue] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [hideEdit, setHideEdit] = useState(false);
  const [isLastPath, setIsLastPath] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [isPathEditable, setIsPathEditable] = useState(true);
  const [isCloseClicked, setIsCloseClicked] = useState(false);
  const [showShipHoldPopup, setShowShipHoldPopup] = useState(false);
  const [isMilestoneSelected, setIsMilestoneSelected] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");
  const [saveTransportData, setSaveTransportData] = useState(false);
  const [shipHoldForm, setShipHoldForm] = useState({
    reason: "",
    estimatedReleaseDate: "",
    comments: "",
  });
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);
  const [auditDetails, setAuditDetails] = useState([]);

  // This reference used to access child components' methods (active tab component methods)
  // in this component through useImperativeHandle hook.
  const activeTabRef = useRef(null);

  // Effect to show edit button for admin users
  useEffect(() => {
    if (controlTowerPermissions.controlTowerEditAccess) {
      setShowEdit(true);
    }
  }, [showEdit]);

  // Function to handle dropdown menu click
  const handleActionDropDownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Function to close the dropdown menu
  const handleActionDropDownClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (
      activeStep != 0 &&
      activeTab === tabs.findIndex((tab) => tab.label === "Logs") &&
      controlTowerPermissions.controlTowerLogsTabAccess
    ) {
      handleAuditDetails();
    } else if (
      activeStep === 0 &&
      activeTab === tabs.findIndex((tab) => tab.label === "Logs")
    ) {
      setAuditDetails([]);
    }
  }, [activeStep, activeTab]);

  const handleAuditDetails = async () => {
    // if tab equals "Logs", then call the getAuditDetails API and set isloading to true
    setIsLoadingLogs(true);
    // Assuming getAuditDetails is a function that fetches audit details
    try {
      const response = await getAuditDetails(activeStep);
      if (response.status === 200) {
        // Handle the response data as needed
        setIsLoadingLogs(false);
        setActiveStep(activeStep);
        setAuditDetails(response);
        setActiveTab(tabs.findIndex((tab) => tab.label === "Logs"));
      } else {
        setIsLoadingLogs(false);
        if (response.status === 204) {
          log(
            response.data.message || "No audit details for this milestone",
            response.status
          );
        } else {
          toast.error(response.data.message);
        }
        //toast.error("No audit details found for this milestone");
      }
    } catch (error) {
      setIsLoadingLogs(false);
      toast.error("Failed to fetch audit details");
    }
  };

  // Function to handle edit action
  const handleEdit = () => {
    const milestoneIndex = sortedMileStoneDetails.findIndex(
      (milestone) => milestone.pathDetails.orderPathId === activeStep
    );

    //CurrentPathStatus to show warning dialog for edit address
    const currentPathStatus =
      sortedMileStoneDetails[milestoneIndex]?.pathDetails?.pathStatus;

    const confirmIndex = STATUS_LIST.indexOf("PICKUP_READY");
    const currentIndex = STATUS_LIST.indexOf(currentPathStatus);

    if (activeTab === 0) {
      // Assuming Address tab is at index 0
      if (currentIndex > confirmIndex) {
        setCurrentStatus(currentPathStatus);
        setOpenConfirmationDialog(true); // Open the confirmation dialog if the status is after CONFIRM
      } else {
        proceedWithEdit(); // Proceed with editing if no confirmation needed
      }
    } else {
      proceedWithEdit(); // For other tabs, just proceed with editing
    }
  };

  const proceedWithEdit = () => {
    setIsEditClicked(true);
    setHideEdit(true);
    setShowSave(true);
    setShowClose(true);
    setIsEditable(true);
    setIsCloseClicked(false);
  };

  const handleDialogClose = () => {
    setOpenConfirmationDialog(false); // Close the dialog
  };

  const handleDialogConfirm = () => {
    setOpenConfirmationDialog(false); // Close the dialog
    proceedWithEdit(); // Proceed with editing
  };

  // Function to handle save action
  const handleSave = async () => {
    if (
      activeTabRef.current &&
      activeTabRef.current.validateFormData &&
      !activeTabRef.current.validateFormData()
    ) {
      return;
    }
    setIsEditClicked(false);
    setHideEdit(false);
    setShowSave(false);
    setShowClose(false);
    if (activeTabRef.current && activeTabRef.current.handleSave) {
      activeTabRef.current.handleSave();
    }
  };

  // Function to handle close action
  const handleClose = () => {
    setIsEditClicked(false);
    setHideEdit(false);
    setShowSave(false);
    setShowClose(false);
    setIsCloseClicked(true);

    if (
      activeTabRef.current &&
      activeTabRef.current.onCloseResetValuesIfNotSaved
    ) {
      activeTabRef.current.onCloseResetValuesIfNotSaved();
    }
  };

  // Function to handle selection of a milestone in the stepper
  const handleSelection = (data) => {
    log("in handle selection of stepper", data);

    setIsMilestoneSelected(true);

    if (isEditClicked) {
      setIsEditClicked(false);
      setHideEdit(false);
      setShowSave(false);
      setShowClose(false);
      setIsEditable(false);
    }
    const orderPathId = data?.pathDetails.orderPathId;
    const sequence = data?.pathDetails.sequence;
    const isLastPathCondition = sequence === sortedMileStoneDetails?.length;

    log("orderPathShipDetails in handleSelection");
    let orderPathShipDetails = {};
    if (shipToDetails?.orderPathId === orderPathId) {
      orderPathShipDetails = { ...shipToDetails };
    }
    log("orderPathId in handleSelection", orderPathId);
    setActiveStep(orderPathId); // Set the active step based on the selected milestone
    setIsLastPath(isLastPathCondition); // Check if the selected milestone is the last path

    if (isLastPathCondition) {
      // Logic for handling the last path
      if (data.pathDetails.arrival === null || isUserAdmin) {
        setShowEdit(true);
        setIsPathEditable(true);
      } else {
        setIsPathEditable(false);
        setShowEdit(false);
      }
    } else {
      log("Not the last path"); // Log for non-last path
    }

    const milestoneTypes = ["ATA", "ATD", "ETA", "ETD"];

    // Prepare the request object based on the selected milestone
    const reqObj = {
      arrival: data.pathDetails.arrival,
      orderPathId: data.pathDetails.orderPathId,
      serial17: serial17,
      orderNumber: orderNumber,
      orderUnit: orderUnit,
      orderYear: orderYear,
      userId: userId,
      start: data.fromLocation.locationDesc,
      destination: data.toLocation.locationDesc,
      forwarder: data.pathDetails.providerName,
      type: data.toLocation.locType,
      DealerAccount: orderPathShipDetails
        ? orderPathShipDetails.shipToMainAcc
          ? orderPathShipDetails.shipToMainAcc
          : data.toLocation.locAccount
        : data.toLocation.locAccount,
      DealerOutlet: orderPathShipDetails
        ? orderPathShipDetails.shipToAccount
          ? orderPathShipDetails.shipToAccount
          : data.toLocation.locAccount
        : data.toLocation.locAccount,
      HubAccount: _.concat(
        data.toLocation.locId,
        " - ",
        data.toLocation.locationDesc
      ),
      HubOutlet: data.toLocation.locAccount,
      toName: orderPathShipDetails
        ? orderPathShipDetails.shipToAccountName
          ? orderPathShipDetails.shipToAccountName
          : data.toLocation.locName
        : data.toLocation.locName,
      toStreet: orderPathShipDetails
        ? orderPathShipDetails.shipToAddress
          ? orderPathShipDetails.shipToAddress
          : data.toLocation.locStreet
        : data.toLocation.locStreet,
      toCity: orderPathShipDetails
        ? orderPathShipDetails.shipToCity
          ? orderPathShipDetails.shipToCity
          : data.toLocation.locCity
        : data.toLocation.locCity,
      toZip: orderPathShipDetails
        ? orderPathShipDetails.shipToZip
          ? orderPathShipDetails.shipToZip
          : data.toLocation.locZip
        : data.toLocation.locZip,
      toCountry: orderPathShipDetails
        ? orderPathShipDetails.shipToCountry
          ? orderPathShipDetails.shipToCountry
          : data.toLocation.locCountry
        : data.toLocation.locCountry,
      logUnit: data.pathDetails.logUnitDescr,
      cost: data.freightDetails.cost,
      currency: data.freightDetails.currency,
      po: data.pathDetails.poNumber,
      forwarderNtf: data.freightDetails.frwdNtfTimestamp,
      forwarderNtfStatus: data.freightDetails.frwdNtfStatus,
      shippingOrder: data.pathDetails.shippingOrder,
      loadingDate: data.freightDetails.loadingDate,
      shippingInstructions: data.pathDetails.freetext,
      startAccountList: countryDealersList,
      pathStatus: data.pathDetails.pathStatus,
      buildId: data.pathDetails.buildId,
      addTime: data.pathDetails.addTime,
      ATA_FOM: data.pathDetails.ata_FOM,
      ATD_FOM: data.pathDetails.atd_FOM,
      ETA_FOM: data.pathDetails.eta_FOM,
      ETD_FOM: data.pathDetails.etd_FOM,
      ATA_JDLINK: data.pathDetails.ATA_JDLINK,
      ATD_JDLINK: data.pathDetails.ATD_JDLINK,
      ETA_JDLINK: data.pathDetails.ETA_JDLINK,
      ETD_JDLINK: data.pathDetails.ETD_JDLINK,
      ATA_MAINCHAIN: data.pathDetails.ata_MAINCHAIN,
      ATD_MAINCHAIN: data.pathDetails.atd_MAINCHAIN,
      ETA_MAINCHAIN: data.pathDetails.eta_MAINCHAIN,
      ETD_MAINCHAIN: data.pathDetails.etd_MAINCHAIN,
      ATA_FORWARDER: data.pathDetails.ATA_FORWARDER,
      ATD_FORWARDER: data.pathDetails.ATD_FORWARDER,
      ETA_FORWARDER: data.pathDetails.ETA_FORWARDER,
      ETD_FORWARDER: data.pathDetails.ETD_FORWARDER,
      ETA_CONTAINER: data.pathDetails.ETA_CONTAINER,
      ATA_CONTAINER: data.pathDetails.ATA_CONTAINER,
      providerId: data.pathDetails.providerId,
    };

    setTabValue(reqObj); // Set the tab value with the request object
  };

  //response data
  const data = {
    orderUnit: orderUnit,
    orderNumber: orderNumber,
    orderYear: orderYear,
    orderPathId: activeStep ? activeStep : shipToDetails.orderPathId,
    mainDealer: tabValue ? tabValue.DealerAccount : shipToDetails.shipToMainAcc,
    shipToAccount: tabValue
      ? tabValue.DealerOutlet
      : shipToDetails.shipToAccount,
    shipToAccountName: tabValue
      ? tabValue.toName
      : shipToDetails.shipToAccountName,
    shipToAccountStreet: tabValue
      ? Array.isArray(tabValue.toStreet)
        ? tabValue.toStreet.filter(Boolean).join(" ").trim()
        : tabValue.toStreet
      : shipToDetails.shipToAddress,
    shipToAccountZip: tabValue ? tabValue.toZip : shipToDetails.shipToZip,
    shipToAccountCity: tabValue ? tabValue.toCity : shipToDetails.shipToCity,
    shipToAccountCountry: tabValue
      ? tabValue.toCountry
      : shipToDetails.shipToCountry,
    userId: userId,
  };

  const handleUrgentClick = async () => {
    if (!activeStep) {
      toast.warning("Please select a milestone!");
      return;
    }
    setIsLoading(true);
    // getShipToDetailsForMachine([orderUnit, orderNumber].join(""));
    try {
      const requestDTO = {
        ...data,
        isShipHold:
          sortedMileStoneDetails[milestoneIndex]?.pathDetails?.isShipHold ??
          false,
        reason:
          sortedMileStoneDetails[milestoneIndex]?.pathDetails?.reason ?? null,
        estimatedReleaseDate:
          sortedMileStoneDetails[milestoneIndex]?.pathDetails
            ?.estimatedReleaseDate ?? null,
        comments:
          sortedMileStoneDetails[milestoneIndex]?.pathDetails?.comments ?? null,
        isUrgent:
          sortedMileStoneDetails[milestoneIndex].pathDetails.isUrgent !==
          undefined
            ? !sortedMileStoneDetails[milestoneIndex].pathDetails.isUrgent
            : false,
      };
      const response = await PostUrgentDetails(requestDTO);
      if (response.status === 200) {
        toast.success(response.data.message);
        getShipToDetailsForMachine([orderUnit, orderNumber].join(""));
      } else {
        setIsLoading(false);
        console.error("Unexpected response status:", response.status);
        throw new Error();
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error:", error);
      toast.error("Failed to update urgent status");
    }
  };

  // Ship Hold Handling
  const handleOpenShipHold = () => {
    if (!activeStep) {
      toast.warning("Please select a milestone!");
      return;
    }
    setShowShipHoldPopup(true);
  };

  const handleShipHoldConfirm = async () => {
    if (!shipHoldForm.reason || !shipHoldForm.estimatedReleaseDate) {
      toast.error("Please fill all required fields");
      return;
    }
    setShowShipHoldPopup(false);
    setIsLoading(true);
    // getShipToDetailsForMachine([orderUnit, orderNumber].join(""));
    try {
      const response = await PostShipHoldDetails({
        ...data,
        isShipHold: true,
        ...shipHoldForm,
        isUrgent:
          sortedMileStoneDetails[milestoneIndex]?.pathDetails?.isUrgent ??
          false,
      });

      if (response.status === 200) {
        toast.success(response.data.message);
        setShipHoldForm({ reason: "", estimatedReleaseDate: "", comments: "" });
        getShipToDetailsForMachine([orderUnit, orderNumber].join(""));
      } else {
        setIsLoading(false);
        throw new Error();
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to apply Ship Hold");
    }
  };

  const handleReleaseShipHold = async () => {
    setIsLoading(true);
    // getShipToDetailsForMachine([orderUnit, orderNumber].join(""));
    try {
      const response = await PostShipHoldDetails({
        ...data,
        isShipHold: false,
        reason: null,
        estimatedReleaseDate: null,
        comments: null,
        isUrgent:
          sortedMileStoneDetails[milestoneIndex]?.pathDetails?.isUrgent ??
          false,
      });
      if (response.status === 200) {
        toast.success(response.data.message);
        getShipToDetailsForMachine([orderUnit, orderNumber].join(""));
      } else {
        setIsLoading(false);
        throw new Error();
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to release Ship Hold");
    }
  };

  const milestoneIndex = sortedMileStoneDetails.findIndex(
    (milestone) => milestone.pathDetails.orderPathId === activeStep
  );
  const sortedmilestoneIndex = sortedMileStoneDetails.findIndex(
    (milestone) => milestone.pathDetails.orderPathId === activeStep
  );

  // Define the tabs for the content sections
  const tabs = [];

  if (controlTowerPermissions.controlTowerAddressTabAccess) {
    tabs.push({
      label: "Address",
      content: (
        <AddressContent
          ref={activeTabRef}
          isCloseClicked={isCloseClicked}
          selectedMilestoneDetails={sortedMileStoneDetails[milestoneIndex]}
          setIsLoading={setIsLoading}
          isPathEditable={isPathEditable}
          showEdit={showEdit}
          isEditable={isEditable}
          isLastPath={isLastPath}
          isEditClicked={isEditClicked}
          tabValue={tabValue}
          getShipToDetailsForMachine={getShipToDetailsForMachine}
        />
      ),
    });
  }

  if (controlTowerPermissions.controlTowerTransportationAndCostingTabAccess) {
    tabs.push({
      label: "Transportation and Costing",
      content: (
        <TransportationContent
          ref={activeTabRef}
          tabValue={tabValue}
          locationList={locationList}
          isEditClicked={isEditClicked}
          logisticUnits={logisticUnits}
          saveTransportData={saveTransportData}
          setIsLoading={setIsLoading}
          getShipToDetailsForMachine={getShipToDetailsForMachine}
          orderUnit={orderUnit}
          orderNumber={orderNumber}
          isUserAdmin={isUserAdmin}
        />
      ),
    });
  }

  if (controlTowerPermissions.controlTowerLogsTabAccess) {
    tabs.push({
      label: "Logs",
      content: <Logs auditDetails={auditDetails} activeStep={activeStep} />,
    });
  }
  if (controlTowerPermissions.controlTowerDatesandStatusTabAccess) {
    tabs.push({
      label: "Dates and Status",
      content: (
        <DateAndStatusesContent
          ref={activeTabRef}
          isUserAdmin={isUserAdmin}
          tabValue={tabValue}
          showEdit={showEdit}
          isEditClicked={isEditClicked}
          setIsLoading={setIsLoading}
          getShipToDetailsForMachine={getShipToDetailsForMachine}
        />
      ),
    });
  }

  // Add Documents tab at the end
// Update the tabs array to conditionally include Documents tab
if (controlTowerPermissions.controlTowerDocumentsTabAccess) {
  tabs.push({
    label: "Documents",
    content: (
      <Documents
        ref={activeTabRef}
        tabValue={tabValue}
        isEditClicked={isEditClicked}
        setIsLoading={setIsLoading}
        getShipToDetailsForMachine={getShipToDetailsForMachine}
      />
    ),
  });
}

  const activeTabLabel = tabs[activeTab]?.label;

  /* Conditions added to disable edit functionality for address tab:
   for not admin:
    1. for all milestone excluding Last milestone.
    2. for last milestone if the destination is "hub/port".
    3. for the last milestone if order is delivered. (checking arrival is not null for that)
    4.for the last milestone if quote has been started/in progress/closed.
    for admin:
    1. for all milestone excluding Last milestone.
    2. for last milestone if the destination is "hub/port".*/
  const isEditDisabled = getEditDisabled({
    isUserAdmin,
    isLastPath,
    activeTabLabel,
    sortedMileStoneDetails,
    milestoneIndex,
    sortedmilestoneIndex,
    controlTowerPermissions,
  });

  return (
    <>
      <Card className="mt-3">
        <CardContent data-fuel-content-divider={"none"}>
          {/* Header Section */}
          <div className="h-[50px] mt-1 px-3 py-1 bg-white flex justify-between items-center">
            <b className="text-xl">
              <span className="pr-2">
                <RouteIcon />
              </span>
              Milestones
            </b>
            <div className="flex gap-2">
              {/* Edit Button (Visible only if conditions met) */}
              {((isUserAdmin && showEdit && !hideEdit) ||
                (controlTowerPermissions.controlTowerEditAccess &&
                  showEdit &&
                  !hideEdit)) && (
                <Button
                  className={`mr-2 uppercase !border-none !transition duration-300 ${
                    isEditDisabled
                      ? "!bg-gray-100 !text-gray-400"
                      : "!bg-gray-100 !text-black hover:!bg-gray-200"
                  }`}
                  onClick={() => handleEdit()}
                  disabled={isEditDisabled}
                >
                  <EditIcon className="mr-1" />
                  <Typography className="uppercase">Edit</Typography>
                </Button>
              )}
              {/* Save Button (Visible only when editing) */}
              {((isUserAdmin && showSave) ||
                (controlTowerPermissions.controlTowerEditAccess &&
                  showSave)) && (
                <Button
                  style={{ marginRight: "8px" }}
                  color="success"
                  onClick={() => handleSave()}
                >
                  <SaveIcon />
                </Button>
              )}
              {/* Close Button (Visible only when editing) */}
              {((isUserAdmin && showClose) ||
                (controlTowerPermissions.controlTowerEditAccess &&
                  showClose)) && (
                <span className="mt-2">
                  <CloseIcon
                    style={{
                      fontSize: "medium",
                      marginBottom: "10px",
                      marginLeft: "-20px",
                    }}
                    onClick={() => handleClose()}
                  />
                </span>
              )}
              {/* Ship Hold Button */}
              {controlTowerPermissions.controlTowerShipHoldActionAccess &&
              milestoneIndex !== -1 &&
              sortedMileStoneDetails[milestoneIndex]?.pathDetails.isShipHold ? (
                <Button
                  className="mr-2 !bg-gray-100 !text-black !border-none !transition duration-300 hover:!bg-gray-200"
                  onClick={handleReleaseShipHold}
                >
                  <span>
                    <ReleaseIcon className="mr-1" />
                  </span>
                  <Typography className="uppercase">
                    Release Ship Hold
                  </Typography>
                </Button>
              ) : (
                controlTowerPermissions.controlTowerShipHoldActionAccess && (
                  <Button
                    onClick={handleOpenShipHold}
                    disabled={!isMilestoneSelected}
                    className={`mr-2 !border-none !transition duration-300 ${
                      !isMilestoneSelected
                        ? "!bg-gray-100 !text-gray-400 cursor-not-allowed"
                        : "!bg-gray-100 !text-black hover:!bg-gray-200"
                    }`}
                  >
                    <span>
                      <PriorityHighIcon className="mr-1" />
                    </span>
                    <Typography className="uppercase">Ship Hold</Typography>
                  </Button>
                )
              )}

              {/* Urgent Button */}
              {controlTowerPermissions.controlTowerUrgentActionAccess && (
                <Button
                  disabled={!isMilestoneSelected}
                  className={`mr-2 !border-none !transition duration-300 ${
                    !isMilestoneSelected
                      ? "!bg-gray-100 !text-gray-400 cursor-not-allowed"
                      : "!bg-gray-100 !text-black hover:!bg-gray-200"
                  }`}
                  onClick={handleUrgentClick}
                >
                  {/* <ReportProblemIcon className="mr-1" /> */}
                  {milestoneIndex !== -1 &&
                  sortedMileStoneDetails[milestoneIndex]?.pathDetails
                    .isUrgent ? (
                    <>
                      <ReleaseIcon className="mr-1" />
                      <Typography className="uppercase">
                        Release Urgent
                      </Typography>
                    </>
                  ) : (
                    <>
                      <RocketLaunchRoundedIcon className="mr-1" />
                      <Typography className="uppercase">Urgent</Typography>
                    </>
                  )}
                </Button>
              )}
              {/*
              Actions Dropdown Button
              <Button
                style={{
                  marginRight: "8px",
                  color: "black",
                  background: "#FFDE00",
                }}
                onClick={handleActionDropDownClick}
                endIcon={<ExpandMoreIcon />}
              >
                Actions
              </Button>
              {/* Actions Dropdown Menu */}
              {/*<Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleActionDropDownClose}
              >
                <MenuItem
                  className="!w-[7rem] flex justify-center items-center text-center"
                  onClick={handleActionDropDownClose}
                >
                  Action 1
                </MenuItem>
                <MenuItem
                  className="!w-[7rem] flex justify-center items-center text-center"
                  onClick={handleActionDropDownClose}
                >
                  Action 2
                </MenuItem>
                <MenuItem
                  className="!w-[7rem] flex justify-center items-center text-center"
                  onClick={handleActionDropDownClose}
                >
                  Action 3
                </MenuItem>
              </Menu> */}
            </div>
          </div>
          {/* condition added to check if milestoneIndex is valid and shiphold is true for that milestone */}
          {milestoneIndex !== -1 &&
            sortedMileStoneDetails[milestoneIndex]?.pathDetails.isShipHold && (
              <div
                style={{
                  backgroundColor: "#FDEFBE",
                  border: "1px solid #FFE99C",
                  borderRadius: "3px",
                }}
              >
                <Row style={{ margin: "10px" }}>
                  <ReportProblemIcon style={{ color: "#FCAB39" }} />
                  <Col>
                    <b>
                      Shipment placed on hold due to{" "}
                      {
                        sortedMileStoneDetails[milestoneIndex].pathDetails
                          .reason
                      }{" "}
                      reason.
                    </b>{" "}
                    {
                      sortedMileStoneDetails[milestoneIndex].pathDetails
                        .comments
                    }{" "}
                    <br />
                    <b>Estimated Release Date:</b>{" "}
                    {
                      sortedMileStoneDetails[milestoneIndex].pathDetails
                        .estimatedReleaseDate
                    }
                    . Please check the details and take necessary action to
                    resolve the issue.
                  </Col>
                </Row>
              </div>
            )}

          {/* Content Section */}
          <div className="w-[850px] flex p-2 m-2">
            <div className="w-[850px] flex-col mr-4">
              {/* Stepper Section for Milestones */}
              <Stepper style={{ width: "300px" }} orientation="vertical">
                {sortedMileStoneDetails.map((milestone, index) => (
                  <Step
                    key={milestone.pathDetails.orderPathId}
                    completed={
                      milestone.pathDetails.arrival !== null ? true : false
                    }
                    onClick={() => handleSelection(milestone)} // Handle selection of milestone on click
                    style={{
                      border:
                        milestone.pathDetails.orderPathId === activeStep
                          ? "2px solid green" // Highlight active step
                          : "none",
                    }}
                  >
                    <StepLabel>
                      {/* Displaying 'fromLocation' and 'toLocation' descriptions */}
                      {`${
                        null != milestone.fromLocation.locationDesc
                          ? milestone.fromLocation.locationDesc
                          : milestone.fromLocation.locName
                      } to ${milestone.toLocation.locationDesc}`}
                      <div class="rounded-md p-0.5 mt-2">
                        {milestone?.pathDetails.isUrgent && (
                          <Badge
                            startIcon={<RocketLaunchRoundedIcon />}
                            variant="info"
                            className="ml-2.5 p-1.25 mb-2.5"
                          >
                            {" "}
                            URGENT
                          </Badge>
                        )}
                        {/* {milestone?.pathDetails.isShipHold && (
                            <Badge
                              startIcon={<PriorityHighIcon />}
                              variant="error"
                              className="ml-2.5 p-1.25 mb-2.5"
                            >
                              {" "}
                              SHIP HOLD
                            </Badge>
                          )} */}
                        {/* HOLD DETAILS Badges */}
                        {milestone?.pathDetails.holdDetails &&
                          Array.isArray(milestone.pathDetails.holdDetails) &&
                          milestone.pathDetails.holdDetails.map(
                            (hold, index) => (
                              <Badge
                                startIcon={<PriorityHighIcon />}
                                variant="error"
                                className="ml-2.5 p-1.25 mb-2.5"
                              >
                                {hold.holdMessage}
                              </Badge>
                            )
                          )}
                        {milestone?.pathDetails.quoteStatus != null &&
                          (milestone?.pathDetails.quoteStatus === "Started" ? (
                            <Badge
                              startIcon={<RequestQuoteIcon />}
                              variant="success"
                              className="ml-2.5 p-1.25 mb-2.5"
                            >
                              {milestone.pathDetails.quoteStatus}
                            </Badge>
                          ) : milestone?.pathDetails.quoteStatus ===
                            "In Progress" ? (
                            <Badge
                              startIcon={<RequestQuoteIcon />}
                              variant="warning"
                              className="ml-2.5 p-1.25 mb-2.5"
                            >
                              {milestone.pathDetails.quoteStatus}
                            </Badge>
                          ) : (
                            <Badge
                              startIcon={<RequestQuoteIcon />}
                              variant="error"
                              className="ml-2.5 p-1.25 mb-2.5"
                            >
                              {milestone.pathDetails.quoteStatus}
                            </Badge>
                          ))}
                      </div>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
            <div className="flex-col mr-4">
              <div>
                <div className="flex border-b border-gray-300">
                  {/* Tab navigation for different content sections */}
                  {tabs.map((tab, index) => (
                    <MachineTab
                      key={index}
                      label={tab.label}
                      isActive={activeTab === index}
                      onClick={() => {
                        // Reset edit states when switching tabs
                        if (isEditClicked) {
                          setIsEditClicked(false);
                          setHideEdit(false);
                          setShowSave(false);
                          setShowClose(false);
                        }
                        setActiveTab(index); // Set the active tab
                      }} // Set the active tab on click
                    />
                  ))}
                </div>
                <div className="mt-5 min-h-[400px] relative w-[1000px]">
                  {isLoadingLogs ? (
                    <div className="flex items-center justify-center h-full min-h-[400px] w-full absolute top-0 left-0 right-[3px]">
                      <LoaderComponent />
                    </div>
                  ) : (
                    tabs[activeTab].content
                  )}
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      <div className="">
        <ShipHoldDialog
          open={showShipHoldPopup}
          onClose={() => setShowShipHoldPopup(false)}
          shipHoldForm={shipHoldForm}
          setShipHoldForm={setShipHoldForm}
          handleShipHoldConfirm={handleShipHoldConfirm}
        />
      </div>
      <div className="">
        {/* Confirmation Dialog for Editing */}
        <ConfirmEditAddressDialog
          open={openConfirmationDialog}
          onClose={() => setOpenConfirmationDialog(false)}
          onConfirm={() => {
            setOpenConfirmationDialog(false);
            proceedWithEdit();
          }}
          status={currentStatus} // Pass the current status to the dialog
        />
      </div>
    </>
  );
};

export default MachineMilestone;
